module.exports = __webpack_public_path__ + "img/iconos2-02.5033a1df.svg";